export const APPSFLYER_APPLE_STORE_URL =
  'https://app.backmarket.com/Mlqg/obdy2rt'
export const APPSFLYER_GOOGLE_PLAY_URL =
  'https://app.backmarket.com/Mlqg/iqkoi7b7'
